import { render, staticRenderFns } from "./super-compare-tool.vue?vue&type=template&id=70271dd2"
import script from "./super-compare-tool.vue?vue&type=script&lang=js"
export * from "./super-compare-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports